<a *ngFor="let locale of supportedLocales | async" (click)="changeLocale(locale)">
  {{ locale.name }}
</a>
